
import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment/invoice`;
const GATEWAYLOC_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment/location`;
const GATEWAYLVEN_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment/vendor`;

export const invoiceService = {

    getInvoiceList: async function (InvoiceNo: any, OrderIds: any, VendorCode: any, ProductCode: any, StartDate: any, EndDate: any) {
        return axios.get(`${GATEWAY_URL}/invoice_list`, {
            params: {
                InvoiceNo: InvoiceNo,
                OrderIds: OrderIds,
                VendorCode: VendorCode,
                ProductCode: ProductCode,
                StartDate: StartDate,
                EndDate: EndDate
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getVendorLookups: async function () {
        // return axios.get(`${GATEWAY_URL}/invoice_vendor_lookup`, {
        return axios.get(`${GATEWAYLVEN_URL}/vendors_suppliers`, {
        })
            .then((response) => {
                return response.data;
            });
    },

    getTermsLookups: async function () { 
        return axios.get(`${GATEWAY_URL}/invoice_terms_lookup`, {
        })
            .then((response) => {
                return response.data;
            });
    },

    getLocationLookups: async function () {
        return axios.get(`${GATEWAYLOC_URL}/location_list`, {
        })
            .then((response) => {
                return response.data;
            });
    },

    getProductLookups: async function () {
        return axios.get(`${GATEWAY_URL}/invoice_product_lookup`, {
        })
            .then((response) => {
                return response.data;
            });
    },

    getInvoice: async function (id: any) {
        return axios.get(`${GATEWAY_URL}/get_invoice`, {
            params: { id }
        })
            .then((response) => {
                return response.data;
            });
    },

    getInvoiceDetailList: async function (InvoiceId: any) {
        return axios.get(`${GATEWAY_URL}/invoice_detail_list`, {
            params: { InvoiceId }
        })
            .then((response) => {
                return response.data;
            });
    },

    updateInvoiceMaster: async function (values: any) {
        return axios.put(`${GATEWAY_URL}/update_invoice`, values) 
            .then((response) => {
                return response.data;
            });
    },

    updateInvoiceDetail: async function (values: any) {
        return axios.put(`${GATEWAY_URL}/save_invoice_detail`, values)
            .then((response) => {
                return response.data;
            });
    },

    invoice_approve: async function (InvoiceId?: number) {
        return axios.get(`${GATEWAY_URL}/invoice_approve`, {
            params: {
                InvoiceId: InvoiceId
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    invoice_reject: async function (invoiceId: number, rejectReason: string) {
        return axios.get(`${GATEWAY_URL}/invoice_reject`, {
            params: {
                InvoiceId: invoiceId,
                RejectReason: rejectReason
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getOrderNoLookups: async function (vendorCode: string, locationCode: string) {
        return axios.get(`${GATEWAY_URL}/invoice_orderno_lookup`, {
            params: {
                VendorCode: vendorCode,
                LocationCode: locationCode
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    orderLinesList: async function (orders: string[]) {
        return axios.post(`${GATEWAY_URL}/order_lines_list`,
            { orderLines: orders }
        )
            .then((response) => {
                return response.data;
            });
    },

    saveInvoice: async function (values: any) {
        return axios.put(`${GATEWAY_URL}/save_invoice`, values)
            .then((response) => {
                return response.data;
            });
    },

    getDownloadInvoicePdf: async (invoiceId: number, fileName: string) => {
        try {
            const response = await axios.get(`${GATEWAY_URL}/download/` + invoiceId + `/` + fileName, {
                responseType: "blob",
                headers: {
                    Accept: ".pdf",
                },
            });
            const blob = new Blob([response.data], {
                type: ".pdf",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Download error :', error);
        }
    }
}

